// src/Edit.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Edit_default = createIcon({
  displayName: "Edit",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M20.7088 5.63126C21.0988 6.02127 21.0988 6.65127 20.7088 7.04127L18.8788 8.87126L15.1288 5.12126L16.9588 3.29126C17.1456 3.10401 17.3993 2.99878 17.6638 2.99878C17.9283 2.99878 18.1819 3.10401 18.3688 3.29126L20.7088 5.63126ZM2.99878 20.5013V17.4613C2.99878 17.3213 3.04878 17.2013 3.14878 17.1013L14.0588 6.19126L17.8088 9.94127L6.88878 20.8513C6.79878 20.9513 6.66878 21.0013 6.53878 21.0013H3.49878C3.21878 21.0013 2.99878 20.7813 2.99878 20.5013Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      })
    ]
  })
});

export {
  Edit_default
};
